export default __webpack_public_path__ + "static/media/Michael Buble - Its Beginning to Look a Lot Like Christmas.681c469e.mp3";